
import Vue from "vue";
import axios from "axios";
// import S_ from 'vue'
import Promise from "promise";
import store from "./index";
import router from "../router";

import { Toast } from "vant";

Vue.use(Toast);

import Loading from '../components/loading.js'
Vue.use(Loading)
// 超时时间
let str = "接口请求超时，请稍后再试";
let toastFlag = true;
// Toast(str);
Vue.prototype.$axios = axios;
axios.defaults.timeout = 10000;

// Indicator({message:"加载中..."})
// http请求拦截器
// console.log(Vue.prototype);
axios.interceptors.request.use(
	config => {
		Vue.prototype.$loading.show()
		//请求前的处理
    // console.log('请求前...', config.url);
    let token = localStorage.getItem("token");
    let schoolCode = localStorage.getItem("schoolCode");
    let channel = localStorage.getItem("channel");
    config.headers["Authorization"] = token;
    config.headers["tschoolCodeoken"] = schoolCode;
    config.headers["channel"] = channel;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http响应拦截器
axios.interceptors.response.use(
	data => {
		Vue.prototype.$loading.hide()
    //请求后的处理
    /**
		 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
		console.log("请求成功后...", data.data);
    console.log(store.state)
    if (data.data.resCode == "0") {
			Toast(data.data.resMsg);
    }
    return data.data;
  },
  error => {
		Vue.prototype.$loading.hide()
		console.log("请求失败后...", error.response.data);
    if (error.response.data.res_code == "400") {
      if(process.env.NODE_ENV == "development"){
        console.log(store.state)
        window.location.href = `https://parent.brightscholar.net/api/parent/third/getAuthorizeUrl?channel=${store.state.channel}&schoolCode=${store.state.schoolCode}`;
      }else{
        window.location.href = `http://apisix.brightscholar.com/api/parent/third/getAuthorizeUrl?channel=${store.state.channel}&schoolCode=${store.state.schoolCode}`;

      }
    }
    return Promise.reject(error.response.data);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/store/httpInterceptor.js